import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-07/task-03";

const task: Slide = {
  titleHtml:
    "When driving a loudspeaker system with a 1 W signal  in its frequency range,  the on-axis pressure level at 1 m<br />is equal to 89 dB. Assuming that the driver behaviour remains linear, what is the pressure level at the same position if<br /> the power of the driving signal is increased to 2 W?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
